export default {
    errors: {
        token_invalid: 'Pozivni token nije validan',
        invitation_unkown_or_used: 'Pozivnica je već iskorišćena ili nevažeća',
    },
    buttons: {
        signup: 'Registracija',
        continue_with_google: 'Nastavi sa Google-om',
        continue_with_apple: 'Nastavi sa Apple-om',
        continue_with_facebook: 'Nastavi sa Facebook-om',
    },
    fields: {
        email: {
            label: 'Email',
            placeholder: "john.jonhson{'@'}myemail.com",
        },
        first_name: {
            label: 'Ime',
            placeholder: 'Pero',
        },
        last_name: {
            label: 'Prezime',
            placeholder: 'Perić',
        },
        password: {
            label: 'Lozinka',
            placeholder: '6 karaktera minimum',
        },
        password_repeat: {
            label: 'Ponoviti lozinku',
            placeholder: 'Unesite lozinku ponovo',
        },
    },
    passwords_not_match: 'Lozinke se ne podudaraju',
    please_register: 'Molimo prijavite se da biste mogli da nastavite',
    no_account: 'Nemate nalog?',
    agrement: `Prihvatam`,
    terms: 'Pravila i uslove korišćenja',
}
